import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import SideNavigation from "../../Menu-sidenavbar/SideNavigation ";
import HeaderBackground from "../../../common/SubpagesBGimage";
import Footer from "../../Layout/Footer";
import Header from "../../Layout/Header";
import { StatutoryCommitteeActions } from "../../../Store/Statutory Committee/action";

function WomenEmpowermentCell() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openKeys, setOpenKeys] = useState([]);
  document.title = "Women Empowerment Cell | PSG-IAP"
  const dispatch = useDispatch();
  const statutorySubpage = useSelector(
    (state) => state.StatutoryCommitteeReducer.StatutoryCommitteeSubpage
  );

  useEffect(() => {
    dispatch({ type: StatutoryCommitteeActions.GET_STATUTORY_COMMITTEE_SUBPAGE });
  }, [dispatch]);

  // Find Women Empowerment Cell data from API
  const committeeData = statutorySubpage.find(
    (item) => item.map_name === "Women Empowerment Cell"
  );

  const chairman = committeeData?.statutory_chairman[0];
  const departments = committeeData?.departments || [];

  return (
    <div>
      <HeaderBackground
        menuName="About Us"
        subMenuName="Statutory Committee"
        thirdLevelName="Women Empowerment Cell"
        handleMenuToggle={() => setIsMenuOpen(!isMenuOpen)}
      />
      <Header />

      <div className="statutory">
        <div className="container committee-container">
          {/* Committee Title */}
          <h6 className="rectangle-title">
            <span className="rectangle-marker"></span>
            {committeeData?.committee_name || "Women Empowerment Cell"}
          </h6>

        

          {/* Chairman Info
          {chairman && (
            <>
              <h5 className="mt-4 text-start subb-title">Chairman</h5>
              <div className="committee-info d-flex align-items-start mb-5">
                <div className="col-md-4 mb-3 committee-image">
                  <img
                    src={chairman.image || "/placeholder.jpg"}
                    alt={chairman.name}
                    className="img-fluid rounded shadow img-thumbnail1"
                  />
                </div>
                <div className="committee-content text-left">
                  <p className="committee-name">{chairman.name}</p>
                  <p className="committee-position">{chairman.designation}</p>
                  <p className="committee-text mb-1">{chairman.address}</p>
                  <p className="committee-text mb-1">{chairman.city}</p>
                  {chairman.phone && (
                    <p className="committee-text mb-1">
                      <span className="label-blue">Phone:</span>{" "}
                      <span className="value-grey">{chairman.phone}</span>
                    </p>
                  )}
                  {chairman.email && (
                    <p className="committee-text mb-1">
                      <span className="label-blue">E-mail:</span>{" "}
                      <span className="value-grey">{chairman.email}</span>
                    </p>
                  )}
                </div>
              </div>
            </>
          )} */}

    {/* Dynamic Committee Content */}
{committeeData?.content ? (
  <div
    className="committee-content mt-4 rect-text rect-bullet"
    style={{
      textAlign: "justify",
      fontSize: "16px",
      lineHeight: "4",
      color: "#333",
      marginBottom: "20px",
      fontFamily: "Poppins, sans-serif",
      
    }}
  >
    <div dangerouslySetInnerHTML={{ __html: committeeData.content }} />
  </div>
) : (
  <p className="text-center mt-4 text-muted">No content available.</p>
)}

          {/* Departments & Members */}
          {departments.map((dept, deptIdx) => (
            <div key={deptIdx} className="mb-5">
              <h5 className="mt-4 text-start subb-title">{dept.department_name}</h5>
              <div className="row mt-3">
                {dept.members.map((member, idx) => (
                   <div className="col-12 col-sm-6 col-lg-4 mb-4" key={idx}>
                    <div className="card member-card text-left p-4 shadow-sm">
                      <h5 className="member-name">{member.member_name}</h5>
                      {member.designation && <p className="member-title">{member.designation}</p>}
                      {member.committee && <p className="member-title">{member.committee}</p>}
                      {member.phone && (
                        <p className="member-text">
                          <span className="label-blue">Mobile No:</span>{" "}
                          <span className="value-grey">{member.phone}</span>
                        </p>
                      )}
                      {member.email && (
                        <p className="member-text">
                          <span className="label-blue">E-mail:</span>{" "}
                          <span className="value-grey">{member.email}</span>
                        </p>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      <SideNavigation
        key="About Us"
        isMenuOpen={isMenuOpen}
        handleMenuToggle={() => setIsMenuOpen(!isMenuOpen)}
        openKeys={openKeys}
        onOpenChange={setOpenKeys}
        defaultOpenSubMenu="About Us"
      />
      <Footer />
    </div>
  );
}

export default WomenEmpowermentCell;


